exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ba-bg-modal[data-v-f7e12bb4]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1500;width:100%;height:93vh;background:hsla(0,0%,64%,.25);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ba-bg-modal .ba-modal[data-v-f7e12bb4]{position:relative;gap:16px;-ms-flex-negative:0;flex-shrink:0;background:#fff;border-radius:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f7e12bb4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/onboarding/components/modal.vue
// module id = sUyz
// module chunks = 0